import React from "react";
import { PagesContainer } from "../../containers";
import { MembershipCardRequestScreen } from "../../screens";

const MembershipCardRequest = (props) => {
  return (
    <PagesContainer {...props}>
      <MembershipCardRequestScreen {...props} />
    </PagesContainer>
  );
};

MembershipCardRequest.defaultProps = {};

export default MembershipCardRequest;
